import React from 'react';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';

// Modified from src/components/accounts-receivable/dialogs/InfoDialog.tsx to also support a
// Cancel button + confirm/cancel callbacks, so a single dialog can stand in for both
// window.alert (plain info, no handleConfirm) and window.confirm (showCancelButton=true).
interface IInfoDialogProps {
    dialogName: string;
    hideDialog: () => void;
    label?: string;
    message?: string;
    heading?: string;
    confirmLabel?: string;
    showCancelButton?: boolean;
    handleConfirm?: () => void;
    handleCancellation?: () => void;
}

const InfoDialog = (props: IInfoDialogProps) => {
    const handleOk = () => {
        props.hideDialog();
        props.handleConfirm?.();
    };

    const handleCancel = () => {
        props.hideDialog();
        props.handleCancellation?.();
    };

    return (
        <Dialog title={props?.heading ? props?.heading : 'Information'} dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '15%' }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <form>
                    ℹ️
                    {!!props?.label && (
                        <>
                            <label>{props.label}</label>
                            <br />
                        </>
                    )}
                    <label style={{whiteSpace: 'normal', wordBreak: 'break-word'}}>{props?.message ? props?.message : ''}</label>
                </form>
            </div>
            <div className="form-row" style={{marginTop: '2rem', justifyContent: 'center'}}>
                <Button
                    className="blue-hover-button"
                    style={{ width: '24%', marginRight: '1rem', whiteSpace: 'nowrap' }}
                    text={props?.confirmLabel ? props.confirmLabel : 'OK'}
                    onClick={() => handleOk()}
                />
                {!!props?.showCancelButton && (
                    <Button
                        className="blue-hover-button"
                        style={{ width: '24%', marginRight: '1rem' }}
                        text={'Cancel'}
                        onClick={() => handleCancel()}
                    />
                )}
            </div>
        </Dialog>
    );
};

export default InfoDialog;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/dialogs/InfoDialog.tsx